import { useState } from 'react'
import { useBookmarkStore } from '../store/bookmarkStore'
import { Button } from './Button'
import { Bookmark } from '../types/bookmark'

interface BatchEditDialogProps {
  onClose: () => void
}

export function BatchEditDialog({ onClose }: BatchEditDialogProps) {
  const {
    selectedBookmarks,
    bookmarks,
    categories,
    updateBookmark,
    addTagToBookmark,
    clearBookmarkSelection,
  } = useBookmarkStore()

  const [categoryId, setCategoryId] = useState<string>('')
  const [newTags, setNewTags] = useState('')
  const [isFavorite, setIsFavorite] = useState<boolean | null>(null)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const selectedIds = Array.from(selectedBookmarks)

    selectedIds.forEach(id => {
      const updates: Partial<Bookmark> = {}

      if (categoryId) {
        updates.categoryId = categoryId === 'none' ? undefined : categoryId
      }

      if (isFavorite !== null) {
        updates.isFavorite = isFavorite
      }

      if (Object.keys(updates).length > 0) {
        updateBookmark(id, updates)
      }

      // 添加新标签
      if (newTags.trim()) {
        newTags
          .split(',')
          .map(tag => tag.trim())
          .filter(Boolean)
          .forEach(tag => {
            addTagToBookmark(id, tag)
          })
      }
    })

    clearBookmarkSelection()
    onClose()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-lg font-medium mb-4">
          批量编辑 ({selectedBookmarks.size} 个书签)
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              修改分类
            </label>
            <select
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
            >
              <option value="">保持不变</option>
              <option value="none">无分类</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              添加标签 (用逗号分隔)
            </label>
            <input
              type="text"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={newTags}
              onChange={(e) => setNewTags(e.target.value)}
              placeholder="标签1, 标签2, ..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              收藏状态
            </label>
            <select
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              value={isFavorite === null ? '' : isFavorite.toString()}
              onChange={(e) => {
                const value = e.target.value
                setIsFavorite(value === '' ? null : value === 'true')
              }}
            >
              <option value="">保持不变</option>
              <option value="true">收藏</option>
              <option value="false">取消收藏</option>
            </select>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <Button variant="outline" onClick={onClose} type="button">
              取消
            </Button>
            <Button type="submit">
              应用更改
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
} 